/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ApproveRouteImport } from './routes/approve'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as CloudRouteImport } from './routes/cloud'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as RequestsRouteImport } from './routes/requests'
import { Route as RulesRouteImport } from './routes/rules'
import { Route as SessionsRouteImport } from './routes/sessions'
import { Route as RecordingsIndexRouteImport } from './routes/recordings.index'
import { Route as RecordingsRecordingIdRouteImport } from './routes/recordings.$recordingId'
import { Route as ServersIndexRouteImport } from './routes/servers.index'
import { Route as ServersServerIdRouteImport } from './routes/servers.$serverId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ApproveRoute = ApproveRouteImport.update({
  id: '/approve',
  path: '/approve',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const CloudRoute = CloudRouteImport.update({
  id: '/cloud',
  path: '/cloud',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectRoute = ConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const RequestsRoute = RequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => rootRouteImport,
} as any)
const RulesRoute = RulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsRoute = SessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordingsIndexRoute = RecordingsIndexRouteImport.update({
  id: '/recordings/',
  path: '/recordings/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordingsRecordingIdRoute = RecordingsRecordingIdRouteImport.update({
  id: '/recordings/$recordingId',
  path: '/recordings/$recordingId',
  getParentRoute: () => rootRouteImport,
} as any)
const ServersIndexRoute = ServersIndexRouteImport.update({
  id: '/servers/',
  path: '/servers/',
  getParentRoute: () => rootRouteImport,
} as any)
const ServersServerIdRoute = ServersServerIdRouteImport.update({
  id: '/servers/$serverId',
  path: '/servers/$serverId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/approve': typeof ApproveRoute
  '/audit': typeof AuditRoute
  '/cloud': typeof CloudRoute
  '/connect': typeof ConnectRoute
  '/requests': typeof RequestsRoute
  '/rules': typeof RulesRoute
  '/sessions': typeof SessionsRoute
  '/recordings/$recordingId': typeof RecordingsRecordingIdRoute
  '/servers/$serverId': typeof ServersServerIdRoute
  '/recordings/': typeof RecordingsIndexRoute
  '/servers/': typeof ServersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/approve': typeof ApproveRoute
  '/audit': typeof AuditRoute
  '/cloud': typeof CloudRoute
  '/connect': typeof ConnectRoute
  '/requests': typeof RequestsRoute
  '/rules': typeof RulesRoute
  '/sessions': typeof SessionsRoute
  '/recordings/$recordingId': typeof RecordingsRecordingIdRoute
  '/servers/$serverId': typeof ServersServerIdRoute
  '/recordings': typeof RecordingsIndexRoute
  '/servers': typeof ServersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/approve': typeof ApproveRoute
  '/audit': typeof AuditRoute
  '/cloud': typeof CloudRoute
  '/connect': typeof ConnectRoute
  '/requests': typeof RequestsRoute
  '/rules': typeof RulesRoute
  '/sessions': typeof SessionsRoute
  '/recordings/$recordingId': typeof RecordingsRecordingIdRoute
  '/servers/$serverId': typeof ServersServerIdRoute
  '/recordings/': typeof RecordingsIndexRoute
  '/servers/': typeof ServersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/approve'
    | '/audit'
    | '/cloud'
    | '/connect'
    | '/requests'
    | '/rules'
    | '/sessions'
    | '/recordings/$recordingId'
    | '/servers/$serverId'
    | '/recordings/'
    | '/servers/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/approve'
    | '/audit'
    | '/cloud'
    | '/connect'
    | '/requests'
    | '/rules'
    | '/sessions'
    | '/recordings/$recordingId'
    | '/servers/$serverId'
    | '/recordings'
    | '/servers'
  id:
    | '__root__'
    | '/'
    | '/approve'
    | '/audit'
    | '/cloud'
    | '/connect'
    | '/requests'
    | '/rules'
    | '/sessions'
    | '/recordings/$recordingId'
    | '/servers/$serverId'
    | '/recordings/'
    | '/servers/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ApproveRoute: typeof ApproveRoute
  AuditRoute: typeof AuditRoute
  CloudRoute: typeof CloudRoute
  ConnectRoute: typeof ConnectRoute
  RequestsRoute: typeof RequestsRoute
  RulesRoute: typeof RulesRoute
  SessionsRoute: typeof SessionsRoute
  RecordingsRecordingIdRoute: typeof RecordingsRecordingIdRoute
  ServersServerIdRoute: typeof ServersServerIdRoute
  RecordingsIndexRoute: typeof RecordingsIndexRoute
  ServersIndexRoute: typeof ServersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/approve': {
      id: '/approve'
      path: '/approve'
      fullPath: '/approve'
      preLoaderRoute: typeof ApproveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cloud': {
      id: '/cloud'
      path: '/cloud'
      fullPath: '/cloud'
      preLoaderRoute: typeof CloudRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/requests': {
      id: '/requests'
      path: '/requests'
      fullPath: '/requests'
      preLoaderRoute: typeof RequestsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rules': {
      id: '/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof RulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions': {
      id: '/sessions'
      path: '/sessions'
      fullPath: '/sessions'
      preLoaderRoute: typeof SessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recordings/': {
      id: '/recordings/'
      path: '/recordings'
      fullPath: '/recordings/'
      preLoaderRoute: typeof RecordingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recordings/$recordingId': {
      id: '/recordings/$recordingId'
      path: '/recordings/$recordingId'
      fullPath: '/recordings/$recordingId'
      preLoaderRoute: typeof RecordingsRecordingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/servers/': {
      id: '/servers/'
      path: '/servers'
      fullPath: '/servers/'
      preLoaderRoute: typeof ServersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/servers/$serverId': {
      id: '/servers/$serverId'
      path: '/servers/$serverId'
      fullPath: '/servers/$serverId'
      preLoaderRoute: typeof ServersServerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ApproveRoute: ApproveRoute,
  AuditRoute: AuditRoute,
  CloudRoute: CloudRoute,
  ConnectRoute: ConnectRoute,
  RequestsRoute: RequestsRoute,
  RulesRoute: RulesRoute,
  SessionsRoute: SessionsRoute,
  RecordingsRecordingIdRoute: RecordingsRecordingIdRoute,
  ServersServerIdRoute: ServersServerIdRoute,
  RecordingsIndexRoute: RecordingsIndexRoute,
  ServersIndexRoute: ServersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
